import { Routes } from '@angular/router'; 
import { ProductsPageComponent } from './components/home/sustainability-preview/sustainability-preview.component';
export const routes: Routes = 
[{path:'',loadComponent:()=>import('./pages/home/home.component').then(m=>m.HomeComponent)

},
{
  path: 'products',
  component: ProductsPageComponent
},{path:'**',redirectTo:''}];
